var app = app || {};
(function ($) {
    app.modals = app.modals || {};

    app.modalManagers = [];

    app.ModalManager = (function () {
        var _normalizeOptions = function (options) {
            if (!options.modalId) {
                options.modalId = `Modal_${Math.floor((Math.random() * 1000000))}${new Date().getTime()}`;
            }

            if (options.modalSize === null) {
                options.modalSize = "";
            } else if (!options.modalSize) {
                // typeof options.modalSize === undefined || options.modalSize === false
                options.modalSize = "modal-lg";
            }

            if (!options.cssClass) {
                options.cssClass = "";
            }

            if (typeof (options.isVerticalCentered) === "undefined" || options.isVerticalCentered === null) {
                options.isVerticalCentered = true;
            }

            if (typeof (options.keyboard) === "undefined") {
                options.keyboard = true;
            }

            if (typeof (options.backdrop) === "undefined") {
                options.backdrop = "static";
            }
        };

        function _removeContainer(modalId) {
            const _containerId = modalId + "Container";
            const _containerSelector = `#${_containerId}`;

            const $container = $(_containerSelector);
            if ($container.length) {
                $container.remove();
            }
        }

        function _createContainer(options) {
            let modalDialogCss = "";
            if (options.modalSize) {
                modalDialogCss += ` ${options.modalSize}`;
            }
            if (options.cssClass) {
                modalDialogCss += ` ${options.cssClass}`;
            }
            if (options.isVerticalCentered) {
                modalDialogCss += " modal-dialog-centered";
            }

            _removeContainer(options.modalId);

            const containerId = options.modalId + "Container";
            return $(`<div id="${containerId}"></div>`)
                .append(
                    `<div id="${options.modalId}" class="modal fade" tabindex="-1" role="modal" aria-hidden="true">
                        <div class="modal-dialog${modalDialogCss}">
                            <div class="modal-content"></div>
                        </div>
                    </div>`
                ).appendTo("body");
        }

        return function (options) {
            _normalizeOptions(options);

            var _options = options;
            var _$modal = null;
            var _modalObject = null;

            var _parent = null;
            var _publicApi = null;
            var _args = null;
            var _data = null;
            var _getResultCallback = null;

            var _onShowingCallback = null;
            var _onShownCallback = null;
            var _onLoadingCallback = null;
            var _onLoadedCallback = null;

            var _onShowingCallbacks = [];
            var _onShownCallbacks = [];
            var _onLoadingCallbacks = [];
            var _onLoadedCallbacks = [];

            var _onClosingCallback = null;
            var _onClosedCallback = null;
            var _onUnloadingCallback = null;
            var _onUnloadedCallback = null;

            var _onClosingCallbacks = [];
            var _onClosedCallbacks = [];
            var _onUnloadingCallbacks = [];
            var _onUnloadedCallbacks = [];

            var _onErrorCallback = null;

            var _onErrorCallbacks = [];

            var _suppressChangeTrackerInit = false;
            var _changeTracker = new app.ChangeTracker();
            var _isSubmitting = false;
            var _isBusy = false;
            var _isOpen = false;
            var _bypassClosePrompt = false;
            var _triggeredCloseButton = null;
            var _isCloseButtonOrEscTriggered = false;
            var _suppressFocusFirstElement = false;

            var _keyboardShortcutManager = null;

            function _showConfirmationPopover(element, promptConfirmation, responseCallback) {
                const popover = $(element).confirmation(
                    app.localize("AreYouSure"),
                    promptConfirmation,
                    responseCallback,
                    {
                        trigger: "manual"
                    });

                const $popover = $(popover)
                    .on("show.bs.popover", function () {
                        _$modal.data("prevent-close", true);
                    })
                    .on("hide.bs.popover", function () {
                        _$modal.removeData("prevent-close");
                    })
                    .one("hidden.bs.popover", function () {
                        if (app.tempusDominusWidgetHideTimer) {
                            clearTimeout(app.tempusDominusWidgetHideTimer);
                        }
                    });

                $popover.popover("show");
            }

            function _hasChanges(sender) {
                let result;
                if (_modalObject && _modalObject.hasChanges) {
                    result = _modalObject.hasChanges.call(_$modal.get(0), _publicApi, { sender: sender });
                }

                if (result === true || result === false) {
                    return result;
                }

                return _changeTracker.hasChanges();
            }

            function _saveModal(sender, alternateSave) {
                if (_isSubmitting) {
                    return;
                }

                if (_modalObject && _modalObject.save) {
                    _isSubmitting = true;

                    const $deferred = _modalObject.save.call(_$modal.get(0), _publicApi, { sender: sender, alternateSave: alternateSave }, _data);
                    if ($deferred === false || $deferred === true || $deferred === null || typeof $deferred === typeof undefined) {
                        _isSubmitting = false;

                        //_keyboardShortcutManager.injectTooltips(_$modal.get(0));
                    } else if ($deferred) {
                        $deferred.always(function () {
                            _isSubmitting = false;

                            //_keyboardShortcutManager.injectTooltips(_$modal.get(0));
                        });
                    }
                }
            }

            function _refresh(doneCallback, cancelledCallback) {
                var $modalContent = $(".modal-content", _$modal);

                abp.ui.setBusy($modalContent);

                const e = $.Event("unloading");

                if (_onUnloadingCallback) {
                    _onUnloadingCallback.call(_publicApi, e);
                }

                $.each(_onUnloadingCallbacks, function (index, value) {
                    value.call(_publicApi, e);
                });

                if (_modalObject && _modalObject.unloading) {
                    _modalObject.unloading.call(_$modal.get(0), _publicApi, _args, _data, e);
                }

                if (e.isDefaultPrevented()) {
                    abp.ui.clearBusy($modalContent);
                    if (cancelledCallback) {
                        cancelledCallback.call(_publicApi);
                    }
                    return;
                }

                if (_onUnloadedCallback) {
                    _onUnloadedCallback.call(_publicApi, e);
                }

                $.each(_onUnloadedCallbacks, function (index, value) {
                    value.call(_publicApi, e);
                });

                if (_modalObject && _modalObject.unloaded) {
                    _modalObject.unloaded.call(_$modal.get(0), _publicApi, _args, _data);
                }

                app.destroy($modalContent);

                if (_options.content || !_options.viewUrl) {
                    $modalContent.empty().append(_options.content);
                    app.modal.createScrollTopElement(_$modal.get(0));

                    if (_onLoadingCallback) {
                        _onLoadingCallback.call(_publicApi, e);
                    }

                    $.each(_onLoadingCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    if (_modalObject && _modalObject.loading) {
                        _modalObject.loading.call(_$modal.get(0), _publicApi, _args, _data);
                    }

                    app.init($modalContent);

                    _changeTracker.clear();
                    if (!_suppressChangeTrackerInit) {
                        _changeTracker.init(_$modal.get(0));
                    }

                    if (_onLoadedCallback) {
                        _onLoadedCallback.call(_publicApi, e);
                    }

                    $.each(_onLoadedCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    if (_modalObject && _modalObject.loaded) {
                        _modalObject.loaded.call(_$modal.get(0), _publicApi, _args, _data);
                    }

                    abp.ui.clearBusy($modalContent);

                    if (doneCallback) {
                        doneCallback.call(_publicApi);
                    }
                } else if (_options.viewUrl) {
                    abp.ajax({
                        url: _options.viewUrl,
                        data: _args,
                        dataType: null,
                        type: "GET",
                        success: function (response, status, jqxhr) {
                            // the response is HTML
                            $modalContent.html(response);
                            app.modal.createScrollTopElement(_$modal.get(0));

                            if (_onLoadingCallback) {
                                _onLoadingCallback.call(_publicApi, e);
                            }

                            $.each(_onLoadingCallbacks, function (index, value) {
                                value.call(_publicApi, e);
                            });

                            if (_modalObject && _modalObject.loading) {
                                _modalObject.loading.call(_$modal.get(0), _publicApi, _args, _data);
                            }

                            app.init(_$modal);

                            _changeTracker.clear();
                            if (!_suppressChangeTrackerInit) {
                                _changeTracker.init(_$modal.get(0));
                            }

                            if (_onLoadedCallback) {
                                _onLoadedCallback.call(_publicApi, e);
                            }

                            $.each(_onLoadedCallbacks, function (index, value) {
                                value.call(_publicApi, e);
                            });

                            if (_modalObject && _modalObject.loaded) {
                                _modalObject.loaded.call(_$modal.get(0), _publicApi, _args, _data);
                            }

                            if (doneCallback) {
                                doneCallback.call(_publicApi);
                            }
                        },
                        error: function (xhr, status, error) {
                            abp.ui.clearBusy($modalContent);
                        }
                    });
                }
            };

            /**
             * Reset the modal programmatically
             * @param {boolean | string} promptConfirmation
             */
            function _reset(promptConfirmation) {
                _resetModal(null, promptConfirmation);
            };

            function _resetModal(sender, promptConfirmation) {
                var execute = function () {
                    if (_isSubmitting) {
                        return;
                    }

                    _isSubmitting = true;

                    if (_modalObject && _modalObject.reset) {
                        const $deferred = _modalObject.reset.call(_$modal.get(0), { sender: sender });

                        if ($deferred === false || $deferred === true || $deferred === null || typeof $deferred === typeof undefined) {
                            _isSubmitting = false;

                            app.modal.createScrollTopElement(_$modal.get(0));
                            _keyboardShortcutManager.injectTooltips(_$modal.get(0));
                        } else if ($deferred) {
                            $deferred.always(function () {
                                _isSubmitting = false;

                                setTimeout(function () {
                                    app.modal.createScrollTopElement(_$modal.get(0));
                                    _keyboardShortcutManager.injectTooltips(_$modal.get(0));
                                });
                            });
                        }
                    } else {
                        _refresh(function () {
                            _isSubmitting = false;

                            _keyboardShortcutManager.injectTooltips(_$modal.get(0));

                            if (!_suppressFocusFirstElement) {
                                app.focusFirstElement(_$modal);
                            }
                        }, function () {
                            _isSubmitting = false;
                        });
                    }
                };

                if (promptConfirmation && _hasChanges(sender)) {
                    if (sender) {
                        _showConfirmationPopover(sender, promptConfirmation, function (isConfirmed) {
                            if (isConfirmed) {
                                execute();
                            }
                        });
                    } else {
                        abp.message.confirm(
                            promptConfirmation,
                            app.localize("AreYouSure"),
                            function (isConfirmed) {
                                if (isConfirmed) {
                                    execute();
                                }
                            },
                            {
                                dangerMode: true
                            });
                    }
                } else {
                    execute();
                }
            }

            function _initAndShowModal() {
                _$modal = $(`#${_options.modalId}`);

                const modalOptions = {
                    keyboard: _options.keyboard,
                    show: false
                };
                if (_options.backdrop) {
                    modalOptions.backdrop = _options.backdrop;
                }

                _$modal.modal(modalOptions);

                if (_args.title || _options.title) {
                    _setHeaderContent(_args.title || _options.title);
                }

                _isSubmitting = false;

                _$modal.on("hide.bs.modal", function (e) {
                    const $modal = $(e.target);

                    const triggeredCloseButton = _triggeredCloseButton;
                    _triggeredCloseButton = null;

                    if (_onClosingCallback) {
                        _onClosingCallback.call(_publicApi, e);
                    }

                    $.each(_onClosingCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    if (_onUnloadingCallback) {
                        _onUnloadingCallback.call(_publicApi, e);
                    }

                    $.each(_onUnloadingCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    if (_modalObject && _modalObject.unloading) {
                        _modalObject.unloading.call(_$modal.get(0), _publicApi, _args, _data, e);
                    }

                    if (!e.isDefaultPrevented()) {
                        if ($modal.data("prevent-close")) {
                            // The codes below are commented out because it's already been catered for in init.js
                            //e.preventDefault();
                            //e.stopPropagation();
                            //e.stopImmediatePropagation();
                            return;
                        } else if ($(".save-button, .save-edit-button, .save-create-button, .save-approve-button", $modal).length === 0) {
                            // the closing of the modal is because the close button or ESC is clicked/pressed.
                            if (triggeredCloseButton || !_bypassClosePrompt) { // if triggeredCloseButton == false && _bypassClosePrompt == false, it means that ESC is pressed
                                _isCloseButtonOrEscTriggered = true;
                            }

                            // there's no save button on the modal, therefore allow close
                            _bypassClosePrompt = true;
                        }

                        if (!_bypassClosePrompt) {
                            const promptConfirmation = $(".close-button", $modal).data("prompt-confirmation");
                            if (promptConfirmation && _hasChanges()) {
                                if (triggeredCloseButton) {
                                    _showConfirmationPopover(triggeredCloseButton, promptConfirmation, function (isConfirmed) {
                                        if (isConfirmed) {
                                            _bypassClosePrompt = true;
                                            // the closing of the modal is because the close button or ESC is clicked/pressed.
                                            _isCloseButtonOrEscTriggered = true;

                                            $modal.modal("hide");
                                        }
                                    });
                                } else {
                                    abp.message.confirm(
                                        promptConfirmation,
                                        app.localize("AreYouSure"),
                                        function (isConfirmed) {
                                            if (isConfirmed) {
                                                _bypassClosePrompt = true;
                                                // the closing of the modal is because the close button or ESC is clicked/pressed.
                                                _isCloseButtonOrEscTriggered = true;

                                                $modal.modal("hide");
                                            }
                                        }, {
                                        dangerMode: true
                                    });
                                }

                                e.preventDefault();
                                e.stopPropagation();
                                e.stopImmediatePropagation();
                                return;
                            } else {
                                // the closing of the modal is allowed and through the close button or ESC.
                                _isCloseButtonOrEscTriggered = true;
                            }
                        } else {
                            _bypassClosePrompt = false;
                        }

                        // The line below should be here instead of in "hidden.bs.modal" event
                        // because in order to destroy an element, the element (especially DataTable) has to be still exists.
                        // In "hidden.bs.modal" event, all elements in the modal have already been removed from the DOM, thus preventing
                        // them to be destroyed.
                        app.destroy($modal);
                    }
                });

                const beforeUnload = function (e) {
                    if ($("body").data("force-redirect")) {
                        return;
                    }

                    if ($(".save-button, .save-edit-button, .save-create-button, .save-approve-button", _$modal).length > 0) {
                        // only prompt if there's a save button.
                        const promptConfirmation = $(".close-button", _$modal).data("prompt-confirmation");
                        if (promptConfirmation && _hasChanges()) {
                            e.preventDefault();

                            e.returnValue = "";

                            return;
                        }
                    }

                    if (_modalObject && _modalObject.browserClosed) {
                        _modalObject.browserClosed.call(_$modal.get(0), _publicApi, _args, _data);
                    }
                };
                _$modal.on("hidden.bs.modal", function (e) {
                    window.removeEventListener("beforeunload", beforeUnload);

                    _isOpen = false;

                    if (_onUnloadedCallback) {
                        _onUnloadedCallback.call(_publicApi, e);
                    }

                    $.each(_onUnloadedCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    if (_modalObject && _modalObject.unloaded) {
                        _modalObject.unloaded.call(_$modal.get(0), _publicApi, _args, _data);
                    }

                    if (_onClosedCallback) {
                        _onClosedCallback.call(_publicApi, e);
                    }

                    $.each(_onClosedCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    if (typeof _options.removeAllOnCloseBindsAfterModalClosed === "boolean" && _options.removeAllOnCloseBindsAfterModalClosed) {
                        _onClosingCallbacks = [];
                        _onClosedCallbacks = [];
                        _onUnloadingCallbacks = [];
                        _onUnloadedCallbacks = [];
                    }

                    _changeTracker.clear();

                    _keyboardShortcutManager.unregister();

                    _removeContainer(_options.modalId);

                    $(".modal").last().focus();

                    app.modalManagers.pop();
                });

                _$modal.on("show.bs.modal", function (e) {
                    _isOpen = true;
                    _isCloseButtonOrEscTriggered = false;

                    const modal = e.target;

                    $(modal).data("modal-manager", _publicApi);
                    _parent = _.last(app.modalManagers)?.manager;

                    if (_onShowingCallback) {
                        _onShowingCallback.call(_publicApi, e);
                    }

                    $.each(_onShowingCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    if (_onLoadingCallback) {
                        _onLoadingCallback.call(_publicApi, e);
                    }

                    $.each(_onLoadingCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    // after showing the Modal, run the modalClass init
                    if (_modalObject && _modalObject.loading) {
                        _modalObject.loading.call(_$modal.get(0), _publicApi, _args, _data);
                    }

                    window.addEventListener("beforeunload", beforeUnload);

                    app.init(modal);

                    const uri = window.URI();
                    if (window.localStorage.getItem(`modalManager-maximize:${_options.modalClass}:${uri.path()}`)) {
                        $("button.header-button.maximize", modal).focus().click();
                    }
                });

                _$modal.on("shown.bs.modal", function (e) {
                    const modal = e.target;

                    //app.init(modal);

                    if (!_suppressChangeTrackerInit) {
                        _changeTracker.init(modal);
                    }

                    if (_onLoadedCallback) {
                        _onLoadedCallback.call(_publicApi, e);
                    }

                    $.each(_onLoadedCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    if (_onShownCallback) {
                        _onShownCallback.call(_publicApi, e);
                    }

                    $.each(_onShownCallbacks, function (index, value) {
                        value.call(_publicApi, e);
                    });

                    if (typeof _options.removeAllOnShowBindsAfterModalOpened === "boolean" && _options.removeAllOnShowBindsAfterModalOpened) {
                        _onShowingCallbacks = [];
                        _onShownCallbacks = [];
                        _onLoadingCallbacks = [];
                        _onLoadedCallbacks = [];
                    }

                    // after shown the Modal, run the modalClass loaded
                    if (_modalObject && _modalObject.loaded) {
                        _modalObject.loaded.call(_$modal.get(0), _publicApi, _args, _data);
                    }

                    if (!_suppressFocusFirstElement) {
                        app.focusFirstElement(modal);
                    }

                    // The code below is to show numeric picker when the modal is shown.
                    // Usually it's already shown when app.init.numberPicker(modal); is called above.
                    // However, in the event that when it was called but the browser tab wasn't active, the numeric pickers will not be shown.
                    // Therefore, the code below acts as a fallback in case when the browser tab is active again (regained focus).
                    //$('input[type="number"]', modal).next().show();

                    abp.ui.clearBusy();

                    app.modalManagers.push({
                        modalClass: _options.modalClass,
                        manager: _publicApi
                    });
                });

                _$modal.on("click", ".save-button", function (e) {
                    const formAttr = $(this).attr("form");

                    if (typeof formAttr !== typeof undefined && formAttr !== false) {
                        e.preventDefault();
                    }

                    // if the save button of a modal is clicked, it will trigger the close of the modal ignoring the prevent-close placed by dropdowns, datetime pickers, popovers
                    $(this).closest(".modal").data("prevent-close", false);

                    _saveModal(this);
                });

                _$modal.on("click", ".save-edit-button", function (e) {
                    e.preventDefault();

                    _saveModal(this, app.consts.alternateSaveType.saveAndEdit);
                });

                _$modal.on("click", ".save-create-button", function (e) {
                    e.preventDefault();

                    _saveModal(this, app.consts.alternateSaveType.saveAndCreate);
                });

                _$modal.on("click", ".save-approve-button", function (e) {
                    e.preventDefault();

                    _saveModal(this, app.consts.alternateSaveType.saveAndApprove);
                });

                _$modal.on("click", ".save-queue-button", function (e) {
                    e.preventDefault();

                    _saveModal(this, app.consts.alternateSaveType.saveAndQueue);
                });

                _$modal.on("click", ".reset-button", function (e) {
                    const formAttr = $(this).attr("form");

                    if (typeof formAttr !== typeof undefined && formAttr !== false) {
                        e.preventDefault();
                    }

                    _resetModal(this, $(this).data("prompt-confirmation"));
                });

                _$modal.on("transitionend", ".modal-dialog", function (e) {
                    if (this === e.target) {
                        // when modal is maximized/restored
                        app.dataTables.adjustColumns(this);
                    }
                });

                _$modal.on("click", "button.header-button.maximize", function () {
                    const $modalDialog = $(".modal-dialog", _$modal);
                    if ($modalDialog.hasClass("modal-sm")) {
                        $modalDialog.data("modal-size", "modal-sm");
                    } else if ($modalDialog.hasClass("modal-lg")) {
                        $modalDialog.data("modal-size", "modal-lg");
                    } else if ($modalDialog.hasClass("modal-xl")) {
                        $modalDialog.data("modal-size", "modal-xl");
                    } else if ($modalDialog.hasClass("modal-xxl")) {
                        $modalDialog.data("modal-size", "modal-xxl");
                    }

                    $modalDialog.removeClass("modal-sm modal-lg modal-xl modal-xxl").addClass("modal-fullscreen");
                    $(this).removeClass("maximize").addClass("restore")
                        .find("i")
                        .removeClass("fa-up-right-and-down-left-from-center")
                        .addClass("fa-down-left-and-up-right-to-center");

                    _keyboardShortcutManager.injectTooltips($(this).parent().get(0));

                    const uri = window.URI();
                    window.localStorage.setItem(`modalManager-maximize:${_options.modalClass}:${uri.path()}`, true);
                });

                _$modal.on("click", "button.header-button.restore", function () {
                    const $modalDialog = $(".modal-dialog", _$modal);
                    $modalDialog.removeClass("modal-fullscreen").addClass($modalDialog.data("modal-size"));

                    $(this).removeClass("restore").addClass("maximize")
                        .find("i")
                        .removeClass("fa-down-left-and-up-right-to-center")
                        .addClass("fa-up-right-and-down-left-from-center");

                    _keyboardShortcutManager.injectTooltips($(this).parent().get(0));

                    const uri = window.URI();
                    window.localStorage.removeItem(`modalManager-maximize:${_options.modalClass}:${uri.path()}`);
                });

                _$modal.on("click", "button.close-button, button.close", function () {
                    _triggeredCloseButton = this;

                    // if the close button of a modal is clicked, it will trigger the close of the modal ignoring the prevent-close placed by dropdowns, datetime pickers, popovers
                    $(this).closest(".modal").data("prevent-close", false);
                });

                _$modal.on("keydown", ".modal-body", function (e) {
                    if (e.key === app.consts.keyboardKey.enter) {
                        const $modal = $(this).closest(".modal");

                        if ($(".save-button", $modal).length > 0
                            && !$modal.data("prevent-close") // if a modal is prevented from closing, it's assumed that there's a pop up visible
                            && !$(e.target).is(":button")
                            && !$(e.target).is("a")) {
                            if (!_isBusy) {
                                if (e.target.tagName.toLocaleLowerCase() === "textarea") {
                                    e.stopPropagation();
                                } else {
                                    e.preventDefault();
                                    if ($(".save-button", $modal).is(":visible")) {
                                        $(".save-button", $modal).focus().click(); // to cause all other controls in the form to lose focus first. Some controls like datetime picker validates on blur.
                                    }
                                    //_saveModal(e.target);
                                }
                            }
                        }
                    }
                });

                _keyboardShortcutManager = new KeyboardShortcutManager(_$modal,
                    [
                        new KeyboardShortcutItem([app.consts.keyboardKey.alt, "`"], null, function (e, $tooltipTarget, manager) {
                            app.focusFirstElement(this);
                        }),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "C"], ".cancel-toggle", function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.is(":visible")) {
                                $tooltipTarget.focus().click();
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "R"], { element: ".restore-entity-button", options: { placement: "right" } }, function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.length > 0) {
                                if ($(".cancel-toggle", this).is(":visible")) {
                                    $(".cancel-toggle", this).focus().click();
                                }

                                setTimeout(function () {
                                    if ($tooltipTarget.is(":visible")) {
                                        $tooltipTarget.focus().click();
                                    }
                                }, 50);
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "A"], { element: ".deactivate-entity-button", options: { placement: "right" } }, function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.length > 0) {
                                if ($(".cancel-toggle", this).is(":visible")) {
                                    $(".cancel-toggle", this).focus().click();
                                }

                                setTimeout(function () {
                                    if ($tooltipTarget.is(":visible")) {
                                        $tooltipTarget.focus().click();
                                    }
                                }, 50);
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "D"], { element: ".delete-entity-button", options: { placement: "right" } }, function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.length > 0) {
                                if ($(".cancel-toggle", this).is(":visible")) {
                                    $(".cancel-toggle", this).focus().click();
                                }

                                setTimeout(function () {
                                    if ($tooltipTarget.is(":visible")) {
                                        $tooltipTarget.focus().click();
                                    }
                                }, 50);
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "S"], ".save-toggle", function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.is(":visible")) {
                                $tooltipTarget.focus().click();
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "E"], { element: ".save-edit-button", options: { placement: "right" } }, function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.length > 0) {
                                if ($(".save-toggle", this).is(":visible")) {
                                    $(".save-toggle", this).focus().click();
                                }

                                setTimeout(function () {
                                    if ($tooltipTarget.is(":visible")) {
                                        $tooltipTarget.focus().click();
                                    }
                                }, 50);
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "N"], { element: ".save-create-button", options: { placement: "right" } }, function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.length > 0) {
                                if ($(".save-toggle", this).is(":visible")) {
                                    $(".save-toggle", this).focus().click();
                                }

                                setTimeout(function () {
                                    if ($tooltipTarget.is(":visible")) {
                                        $tooltipTarget.focus().click();
                                    }
                                }, 50);
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "W"], { element: ".save-approve-button", options: { placement: "right" } }, function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.length > 0) {
                                if ($(".save-toggle", this).is(":visible")) {
                                    $(".save-toggle", this).focus().click();
                                }

                                setTimeout(function () {
                                    if ($tooltipTarget.is(":visible")) {
                                        $tooltipTarget.focus().click();
                                    }
                                }, 50);
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, "Q"], { element: ".save-queue-button", options: { placement: "right" } }, function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.length > 0) {
                                if ($(".save-toggle", this).is(":visible")) {
                                    $(".save-toggle", this).focus().click();
                                }

                                setTimeout(function () {
                                    if ($tooltipTarget.is(":visible")) {
                                        $tooltipTarget.focus().click();
                                    }
                                }, 50);
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, "Q"], ".reset-button", function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.is(":visible")) {
                                $tooltipTarget.focus().click();
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, "S"], ".save-button", function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.is(":visible")) {
                                $tooltipTarget.focus().click();
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, app.consts.keyboardKey.arrowUp], ".header-button.maximize", function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.is(":visible")) {
                                $tooltipTarget.focus().click();
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.control, app.consts.keyboardKey.alt, app.consts.keyboardKey.arrowDown], ".header-button.restore", function (e, $tooltipTarget, manager) {
                            e.stopPropagation();
                            e.preventDefault();

                            if ($tooltipTarget.is(":visible")) {
                                $tooltipTarget.focus().click();
                            }
                        }, _$modal),
                        new KeyboardShortcutItem([app.consts.keyboardKey.escape], ".close-button, .close", null, _$modal)
                    ]);

                const ModalClass = app.modals[_options.modalClass];
                if (!_modalObject && ModalClass) {
                    // before showing the Modal, run the modalClass constructor
                    _modalObject = new ModalClass(_publicApi);
                }

                _$modal.modal("show");
            }

            var _open = function (args, opts) {
                function loadScriptsAndDisplayModal() {
                    if (_options.styleUrls) {
                        let styleUrls = _options.styleUrls;
                        if (!Array.isArray(styleUrls)) {
                            styleUrls = [styleUrls];
                        }

                        $.each(styleUrls, function (index, value) {
                            app.ResourceLoader.loadStyle(value);
                        });
                    }

                    if (_options.scriptUrls) {
                        // if _options.scriptUrls is a string, then _options.scriptUrls is the URL to the script file.
                        // if _options.scriptUrls is an array of strings, then each item in the array is the URL to a script file and are loaded synchronously one after another in order.
                        // if _options.scriptUrls is an array of a mixture of strings and arrays, the inner arrays will be arrays of strings (the URL of a script) that will be loaded asynchronously.
                        // in short, items in outer array are loaded synchronously, items in inner array are loaded asynchronously.

                        let scriptUrls = _options.scriptUrls;
                        if (!Array.isArray(scriptUrls)) {
                            scriptUrls = [scriptUrls];
                        }

                        // load multiple scripts
                        let scriptPromise = new Promise((resolve, reject) => {
                            function loadScripts(urls) {
                                const url = urls.shift();
                                if (url) {
                                    if (Array.isArray(url)) {
                                        // if the item is an array (inner array), then load all the items inside it asynchronously.
                                        const promises = [];
                                        $.each(url, function (i, v) {
                                            const promise = app.ResourceLoader.loadScript(v);
                                            if (promise) {
                                                promises.push(promise);
                                            }
                                        });

                                        $.when.apply($, promises).done(function () {
                                            loadScripts(urls);
                                        });
                                    } else {
                                        // item is a string (url).
                                        const promise = app.ResourceLoader.loadScript(url);
                                        if (promise) {
                                            promise.done(function () {
                                                loadScripts(urls);
                                            });
                                        } else {
                                            loadScripts(urls);
                                        }
                                    }
                                } else {
                                    resolve();
                                }
                            }

                            loadScripts(scriptUrls);
                        });

                        scriptPromise.then(() => {
                            _initAndShowModal();
                        });

                        /*
                        // wait for all scripts to finished loading, only then show modal
                        // the ... operator below is the spread syntax (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax)
                        // $.when() is expecting 'param array' of promises (not array of promises), so the spread syntax will turn an array passed in and spread it like $.when(promises[0], promises[1], ..., promises[n])
                        // this syntax is available in EcmaScript which only more modern browser supports.
                        //$.when(...promises).done(function () {
                        //    _initAndShowModal();
                        //});

                        // let's try a different approach using jQuery's $.when.apply()
                        $.when.apply($, promises).then(function () {
                            _initAndShowModal();
                        });
                        // the anonymous function in "then()" will only be called on success. In order to call a function on reject, chain it with "fail()":
                        // $.when.apply($, processItemsDeferred).then(everythingDone).fail(noGood);
                        */
                    } else {
                        _initAndShowModal();
                    }
                }

                _args = args || {};
                _data = opts?.data || {};
                _getResultCallback = opts?.getResultCallback;
                _onShowingCallback = opts?.onShowingCallback;
                _onShownCallback = opts?.onShownCallback;
                _onLoadingCallback = opts?.onLoadingCallback;
                _onLoadedCallback = opts?.onLoadedCallback;
                _onClosingCallback = opts?.onClosingCallback;
                _onClosedCallback = opts?.onClosedCallback;
                _onUnloadingCallback = opts?.onUnloadingCallback;
                _onUnloadedCallback = opts?.onUnloadedCallback;
                _onErrorCallback = opts?._onErrorCallback;

                abp.ui.setBusy();

                if (_modalObject && _modalObject.init) {
                    _modalObject.init(_publicApi, _args, _data);
                }

                if (_options.content || !_options.viewUrl) {
                    const $modalContent = _createContainer(_options)
                        .find(".modal-content");

                    $modalContent.append(_options.content);

                    loadScriptsAndDisplayModal();

                    abp.ui.clearBusy();
                } else if (_options.viewUrl) {
                    abp.ajax({
                        url: _options.viewUrl,
                        data: _args,
                        dataType: null,
                        type: "GET",
                        traditional: true,
                        success: function (response, status, jqxhr) {
                            const $modalContent = _createContainer(_options)
                                .find(".modal-content");

                            // the response is HTML
                            $modalContent.append(response);

                            loadScriptsAndDisplayModal();
                        },
                        error: function (xhr, status, error) {
                            if (_onErrorCallback) {
                                _onErrorCallback.call(_publicApi, xhr, status, error);
                            }

                            $.each(_onErrorCallbacks, function (index, value) {
                                value.call(_publicApi, xhr, status, error);
                            });

                            abp.ui.clearBusy();
                        }
                    });
                }
            };

            const _onShowing = function (onShowingCallback) {
                _onShowingCallbacks.push(onShowingCallback);
            };

            const _onShown = function (onShownCallback) {
                _onShownCallbacks.push(onShownCallback);
            };

            const _onLoading = function (onLoadingCallback) {
                _onLoadingCallbacks.push(onLoadingCallback);
            };

            const _onLoaded = function (onLoadedCallback) {
                _onLoadedCallbacks.push(onLoadedCallback);
            };

            const _close = function (bypassClosePrompt = true, opts = null) {
                if (!_$modal) {
                    return;
                }

                _bypassClosePrompt = bypassClosePrompt;

                if (opts?.onUnloadingCallback) {
                    _onUnloadingCallback = opts.onUnloadingCallback;
                }

                if (opts?.onUnloadedCallback) {
                    _onUnloadedCallback = opts.onUnloadedCallback;
                }

                if (opts?.onClosingCallback) {
                    _onClosingCallback = opts.onClosingCallback;
                }

                if (opts?.onClosedCallback) {
                    _onClosedCallback = opts.onClosedCallback;
                }

                if (opts?.onErrorCallback) {
                    _onErrorCallback = opts.onErrorCallback;
                }

                _$modal.modal("hide");
            };

            const _onClosing = function (onClosingCallback) {
                _onClosingCallbacks.push(onClosingCallback);
            };

            const _onClosed = function (onClosedCallback) {
                _onClosedCallbacks.push(onClosedCallback);
            };

            const _onUnloading = function (onUnloadingCallback) {
                _onUnloadingCallbacks.push(onUnloadingCallback);
            };

            const _onUnloaded = function (onUnloadedCallback) {
                _onUnloadedCallbacks.push(onUnloadedCallback);
            };

            const _onError = function (onErrorCallback) {
                _onErrorCallbacks.push(onErrorCallback);
            };

            function _setBusy(isBusy, skipCloseButtons) {
                if (!_$modal) {
                    return;
                }

                if (skipCloseButtons) {
                    _$modal.find(".modal-footer button").not(".close-button").buttonBusy(isBusy);
                } else {
                    _$modal.find(".modal-footer button").buttonBusy(isBusy);
                    _$modal.find(".modal-header button.close").buttonBusy(isBusy);

                    // prevent the modal from closing by pressing ESC when the modal is busy
                    if (isBusy) {
                        _$modal.data("bs.modal")._config.keyboard = false;
                    } else {
                        _$modal.data("bs.modal")._config.keyboard = true;
                    }
                }

                _isBusy = isBusy;
            }

            function _setSubmitting(isSubmitting) {
                if (!_$modal) {
                    return;
                }

                _isSubmitting = isSubmitting;
            }

            function _setHeaderContent(headerContent) {
                if (!_$modal) {
                    return;
                }

                _$modal.find(".modal-header .modal-title").html(headerContent);
            }

            _publicApi = {
                isOpen: function () {
                    return _isOpen;
                },

                isCloseButtonOrEscTriggered: function () {
                    return _isCloseButtonOrEscTriggered;
                },

                open: _open,

                reopen: function () {
                    _open(_args, {
                        getResultCallback: _getResultCallback,
                        onShowingCallback: _onShowingCallback,
                        onShownCallback: _onShownCallback,
                        onLoadingCallback: _onLoadingCallback,
                        onLoadedCallback: _onLoadedCallback,
                        onClosingCallback: _onClosingCallback,
                        onClosedCallback: _onClosedCallback,
                        onUnloadingCallback: _onUnloadingCallback,
                        onUnloadedCallback: _onUnloadedCallback,
                        onErrorCallback: _onErrorCallback,
                        data: _data
                    });
                },

                refresh: _refresh,

                reset: _reset,

                close: _close,

                getParent: function () {
                    return _parent;
                },

                getModalId: function () {
                    return _options.modalId;
                },

                getModal: function () {
                    return _$modal;
                },

                getArgs: function () {
                    return _args;
                },

                setArgs: function (args) {
                    _args = args || {};
                },

                getData: function () {
                    return _data;
                },

                setData: function (data) {
                    _data = data || {};
                },

                getOptions: function () {
                    return _options;
                },

                setOptions: function (options) {
                    _options = options;
                },

                setBusy: _setBusy,

                setSubmitting: _setSubmitting,

                setResult: function (...args) {
                    return _getResultCallback && _getResultCallback.call(_publicApi, ...args);
                },

                onShowing: _onShowing,

                onShown: _onShown,

                onLoading: _onLoading,

                onLoaded: _onLoaded,

                onClosing: _onClosing,

                onClosed: _onClosed,

                onUnloading: _onUnloading,

                onUnloaded: _onUnloaded,

                onError: _onError,

                getModalObject: function () {
                    return _modalObject;
                },

                setHeaderContent: _setHeaderContent,

                getChangeTracker: function () {
                    return _changeTracker;
                },

                suppressChangeTrackerInit: function (value = true) {
                    _suppressChangeTrackerInit = value;
                },

                initChangeTracker: function (container = null) {
                    if (!container) {
                        container = _$modal.get(0);
                    }

                    _changeTracker.init(container);
                },

                suppressFocusFirstElement: function (value = true) {
                    _suppressFocusFirstElement = value;
                },

                getKeyboardShortcutManager: function () {
                    return _keyboardShortcutManager;
                }
            };

            return _publicApi;
        };
    })();
})(jQuery);
